<template>
   <b-button-group
      v-if="customerOrder && orderStates"
      class="d-flex pt-2"
      vertical
      block
   ><!-- button-group -->
      <coi-action-bar-unfreeze-order
         :customerOrder="customerOrder"
         :orderStates="orderStates"
         @mutatedOrderState="mutatedOrderState"
      />
      <coi-action-reopen-postponed-order
         :customerOrder="customerOrder"
         :orderStates="orderStates"
         @mutatedOrderState="mutatedOrderState"
      />
      <coi-action-bar-refund
         :customerOrder="customerOrder"
         :orderStates="orderStates"
         :authorization="authorization"
         @mutatedOrderState="mutatedOrderState"
      />
      <!-- Erstatten OM -->
      <coi-action-bar-refund-silent
         :customerOrder="customerOrder"
         :orderStates="orderStates"
         :authorization="authorization"
         @mutatedOrderState="mutatedOrderState"
      />

      <coi-action-bar-remove-tracking
         :customerOrder="customerOrder"
         :authorization="authorization"
         :orderStates="orderStates"
         @mutatedCustomerOrder="mutatedCustomerOrder"
      ></coi-action-bar-remove-tracking>

      <coi-action-bar-mark-parcel-loss
         :customerOrder="customerOrder"
         :orderStates="orderStates"
         :vendors="vendors"
         :marketAccounts="marketAccounts"
      ></coi-action-bar-mark-parcel-loss>
      
      <!-- 
      <coi-action-bar-create-return
         :customerOrder="customerOrder"
         :orderStates="orderStates"
         :vendors="vendors"
         :marketAccounts="marketAccounts"
        ></coi-action-bar-create-return>
      -->

      <coi-action-bar-download-invoice
         :customerOrderId="customerOrder.id"
         :customerOrderItemDeliveryAddition="customerOrder.customerorderitems[0].customerorderitemdeliveryaddition"
      ></coi-action-bar-download-invoice>

      <!--
         <coi-action-bar-vendor-cancellation
            :customerOrder="customerOrder"
            :disabled="true"
         ></coi-action-bar-vendor-cancellation>
      -->

      <coi-action-bar-change-vendor
         :customerOrder="customerOrder"
         :orderStates="orderStates"
         :vendors="vendors"
         :authorization="authorization"
         @mutatedStock="mutatedStock"
      ></coi-action-bar-change-vendor>

      <coi-action-bar-reorder
         :customerOrder="customerOrder"
         :orderStates="orderStates"
      ></coi-action-bar-reorder>

      <coi-action-bar-cancel-delivery-submission
         :customerOrderItemDelivery="customerOrder.customerorderitems[0].customerorderitemdeliveries[0]"
         :customerOrderId="customerOrder.id"
         :orderStates="orderStates"
         :authorization="authorization"
         @mutatedCustomerOrderItemDelivery="mutatedCustomerOrderItemDelivery"
      ></coi-action-bar-cancel-delivery-submission>


      <coi-action-bar-death-certificate
         :customerOrder="customerOrder"
         :authorization="authorization"
     ></coi-action-bar-death-certificate>

     <coi-action-bar-postal-return
         :customerOrder="customerOrder"
         :authorization="authorization"
     ></coi-action-bar-postal-return>

    <coi-action-bar-blacklist-testbuyer
        :address="customerOrder.address"
        :authorization="authorization"
    ></coi-action-bar-blacklist-testbuyer>

     <coi-action-bar-direct-stocking
         :customerOrder="customerOrder"
         :authorization="authorization"
     ></coi-action-bar-direct-stocking>

   </b-button-group>
</template>
<script>
import COIActionBarCancelDeliverySubmission from './COIActionBarCancelDeliverySubmission.vue';
export default {
	components: { COIActionBarCancelDeliverySubmission },
   props: ['customerOrder', 'orderStates', 'vendors', 'marketAccounts', 'authorization'],
   data() { return { } },
   methods: {
      mutatedStock(newStock)                 { this.$emit('mutatedStock'        , newStock        ) }
    , mutatedCustomerOrder(newCustomerOrder) { this.$emit('mutatedCustomerOrder', newCustomerOrder) }
    , mutatedOrderState(newOrderState)       { this.$emit('mutatedOrderState'   , newOrderState   ) }
    , mutatedCustomerOrderItemDelivery(newCustomerOrderItemDelivery) {this.$emit('mutatedCustomerOrderItemDelivery', newCustomerOrderItemDelivery)}
   }
};
</script>
